<template>
  <modal :active="active" @close="handleCloseModal">
    <div slot="title">Select Media File</div>
    <spinner v-if="searchingMediaFiles" />
    <pagination
      v-else
      @selectMediaFile="chooseFile"
      :data="mediaFiles"
      scope="props"
      itemTemplate="mediaFile"
      :itemTemplateProps="file ? file : null"
      :classes="['mediaClass', 'col-12']"
    ></pagination>
    <div slot="footer" style="display: flex">
      <div style="margin-right: 10px">
        <file-uploader
          :active="showFileUploaderModal"
          @closeRequest="toggleMediaBrowserModal"
          @finished="loadBrowser()"
        ></file-uploader>
        <button @click="toggleMediaBrowserModal()" class="btn btn-warning">
          <i style="font-size: 20px; color: white" class="fa fa-arrow-up"></i>
        </button>
      </div>
      <button @click="selectFile" :disabled="!file" class="btn btn-success">
        <i class="fa fa-arrow-circle-down"></i>
        Select
      </button>
    </div>
  </modal>
</template>
<script>
import { mapState } from "vuex";
import Pagination from "./Pagination.vue";
import Modal from "../../components/Modal.vue";
import FileUploader from "./FileUploader.vue";
import MediaFilesFilter from "../../filters/MediaFilesFilter";
import Spinner from "vue-simple-spinner";

export default {
  props: ["active", "filterBy"],
  data() {
    return {
      file: null,
      showFileUploaderModal: false,
      imageExtensions: ["jpg", "jpeg", "png"],
      audioExtensions: ["wav", "mp3"],
      videoExtensions: ["mp4", "flv", "3gp", "avi", "wmv", "vob"],
      documentExtensions: ["pptx", "docx", "doc", "pdf"],
    };
  },
  created: function () {
    // var mediaFileFilter = MediaFilesFilter();
    // if (this.filterBy == "images") {
    //   mediaFileFilter.types = this.imageExtensions;
    // } else if (this.filterBy == "audios") {
    //   mediaFileFilter.types = this.audioExtensions;
    // } else if (this.filterBy == "videos") {
    //   mediaFileFilter.types = this.videoExtensions;
    // } else if (this.filterBy == "documents") {
    //   mediaFileFilter.types = this.documentExtensions;
    // }
    // this.$store.dispatch("searchMediaFiles", {
    //   filter: mediaFileFilter,
    //   resultMode: "paginated",
    // });
  },
  components: {
    Pagination,
    Modal,
    FileUploader,
    Spinner,
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      mediaFiles: (state) => state.mediaStore.mediaSearch.mediaFiles,
      searchingMediaFiles: (state) =>
        state.mediaStore.mediaSearch.searchingMediaFiles,
    }),
  },
  methods: {
    chooseFile(mediaFile) {
      this.file = mediaFile;
    },
    loadBrowser() {
      var mediaFileFilter = MediaFilesFilter();
      if (this.filterBy == "images") {
        mediaFileFilter.types = this.imageExtensions;
      } else if (this.filterBy == "audios") {
        mediaFileFilter.types = this.audioExtensions;
      } else if (this.filterBy == "videos") {
        mediaFileFilter.types = this.videoExtensions;
      } else if (this.filterBy == "documents") {
        mediaFileFilter.types = this.documentExtensions;
      }
      if (this.authUser.userable_type == "administrator") {
        mediaFileFilter.userable_type = this.authUser.userable_type;
      } else {
        mediaFileFilter.userable_type = this.authUser.userable_type;
        mediaFileFilter.userable_ids = [this.authUser.userable_id];
      }
      this.$store.dispatch("searchMediaFiles", {
        filter: mediaFileFilter,
        resultMode: "paginated",
      });
    },
    selectFile() {
      this.$emit("fileSelected", this.file);
      this.$emit("input", this.file);
      this.handleCloseModal();
    },
    handleCloseModal() {
      this.file = null;
      this.$emit("closeRequest");
    },
    toggleMediaBrowserModal() {
      this.showFileUploaderModal = !this.showFileUploaderModal;
    },
  },
  watch: {
    active() {
      if (this.active) {
        var mediaFileFilter = MediaFilesFilter();
        if (this.filterBy == "images") {
          mediaFileFilter.types = this.imageExtensions;
        } else if (this.filterBy == "audios") {
          mediaFileFilter.types = this.audioExtensions;
        } else if (this.filterBy == "videos") {
          mediaFileFilter.types = this.videoExtensions;
        } else if (this.filterBy == "documents") {
          mediaFileFilter.types = this.documentExtensions;
        }
        if (this.authUser.userable_type == "administrator") {
          mediaFileFilter.userable_type = this.authUser.userable_type;
        } else {
          mediaFileFilter.userable_type = this.authUser.userable_type;
          mediaFileFilter.userable_ids = [this.authUser.userable_id];
        }

        this.$store.dispatch("searchMediaFiles", {
          filter: mediaFileFilter,
          resultMode: "paginated",
        });
      }
    },
  },
};
</script>
<style>
.mediaClass {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
}
.btn-success {
  background-color: #8cc63f;
  border-color: #8cc63f;
}
.btn-success:disabled {
  background-color: #8cc63f;
  border-color: #8cc63f;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/common/MediaBrowser.vue